// extracted by mini-css-extract-plugin
export default {"loadingDots":"LoadingDots_loadingDots__uT6k4","dot":"LoadingDots_dot__sw0IV","loadingAnimation":"LoadingDots_loadingAnimation__nKvL6"};